module.exports = __webpack_public_path__ + "img/Simple Brown.56e4fc48.jpg";